<template>
  <div>
    <!-- 搜索 -->
    <el-row class="auto-message__search">
      <span>策略类型</span>
      <el-select v-model="searchList.strategyType" filterable placeholder="请选择">
        <el-option v-for="item in strategyTypeList" :key="item.value" :label="item.name"
          :value="item.value"></el-option>
      </el-select>
      <span>状态</span>
      <el-select v-model="searchList.valid" placeholder="请选择">
        <el-option key="0" label="下线" :value="0"> </el-option>
        <el-option key="1" label="上线" :value="1"> </el-option>
      </el-select>
      <span>语言</span>
      <el-select v-model="searchList.lang" filterable placeholder="请选择">
        <el-option v-for="(item, index) in langList" :key="index" :label="item.language"
          :value="item.langCode"></el-option>
      </el-select>
      <el-button style="margin-left: 10px" type="success" @click="getAllMessage(0)">搜索</el-button>
      <el-button style="margin-left: 10px" type="success" @click="addMessage">添加</el-button>
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-table border :data="messageList">
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="name" label="名称" align="center">
        </el-table-column>
        <el-table-column prop="channel" label="渠道" align="center">
        </el-table-column>
        <el-table-column label="策略类型" align="center">
          <template slot-scope="scope">
            {{ getName(scope.row.strategyType, strategyTypeList) }}
          </template>
        </el-table-column>
        <el-table-column prop="lang" label="语言" align="center">
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.valid === 0 ? '下线' : '上线' }}
          </template>
        </el-table-column>
        <el-table-column prop="mtime" label="操作时间" align="center" :formatter="formatDate">
        </el-table-column>
        <el-table-column prop="operator" label="操作人" align="center">
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="360">
          <template slot-scope="scope">
            <el-button type="primary" @click="updateAutoMessage(scope.row)">编辑</el-button>
            <el-button type="success" @click="copyAutoMessage(scope.row)">复制</el-button>
            <el-button :type="scope.row.valid === 1 ? 'danger' : 'warning'" @click="changeValid(scope.row)">{{
              scope.row.valid === 1 ? '下线' : '上线' }}</el-button>
            <el-button type="info" @click="deleteMessage(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 分页 -->
    <el-row>
      <el-pagination background layout="prev, pager, next" :total="totalPage" :page-size="pageSize"
        :current-page.sync="currentPage" @current-change="guaranteedHandleCurrentChange">
      </el-pagination>
    </el-row>
    <!-- 弹出框 -->
    <el-dialog :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="messageDialog" title="策略内容配置" width="70%">
      <el-form :rules="rules" ref="ruleForm" :model="form" label-width="120px">
        <el-form-item label="策略名称" label-width="120px" prop="name" placeholder="请输入名称" v-if="type === 0">
          <el-input v-model.trim="form.name" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="渠道" label-width="120px" prop="channel">
          <el-select v-model="form.channel" style="width: 400px" filterable placeholder="请选择">
            <el-option v-for="item in channelList" :key="item.channelId" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="策略类型" label-width="120px" prop="strategyType">
          <el-select v-model="form.strategyType" filterable placeholder="请选择" style="width: 400px">
            <el-option v-for="item in strategyTypeList" :key="item.value" :label="item.name"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" label-width="120px">
          <el-input v-model="form.remark" type="textarea" style="width: 400px" placeholder="请输入内容" :autosize="true"
            :maxlength="400"></el-input>
        </el-form-item>
        <el-form-item label="语言" label-width="120px" prop="lang">
          <el-select v-model="form.lang" filterable placeholder="请选择" style="width: 400px">
            <el-option v-for="(item, index) in langList" :key="index" :label="item.language"
              :value="item.langCode"></el-option>
          </el-select>
        </el-form-item>
        <el-row>
          <draggable v-model="loginMessage">
            <transition-group>
              <div class="item" v-for="(item, index) in loginMessage" :key="item.nodeIndex">
                <span>{{ getName(item.contentType, autoMessageList) }}信</span>

                <div class="item-content">
                  <el-input v-model="item.delayTime" type="number" style="width: 250px">
                    <template slot="prepend">延迟时间</template>
                    <template slot="append">秒</template>
                  </el-input>
                </div>
                <div class="item-content" v-if="item.contentType === 1 && item.contentType !== 101">
                  <el-input v-model="item.content" style="min-width: 300px" @pointerdown.stop.native>
                    <template slot="prepend">文本内容</template>
                  </el-input>
                </div>
                <div class="item-content" v-if="
                  item.contentType !== 101 && item.contentType !== 5 && item.contentType == 2
                ">
                  <el-input v-model="item.url" style="min-width: 300px" @pointerdown.stop.native>
                    <template slot="prepend">
                      url
                    </template>
                  </el-input>
                </div>
                <div class="item-content" v-if="
                  item.contentType !== 101 && item.contentType !== 5 && item.contentType !== 2
                ">
                  <el-select @change="handleUrlTypeChange(item)" v-model="item.urlType" filterable placeholder="请选择">
                    <el-option v-for="item in urlTypeList" :key="item.value" :label="item.name"
                      :value="item.value"></el-option>
                  </el-select>
                  <el-input v-if="item.urlType == 1" v-model="item.url" @pointerdown.stop.native>
                  </el-input>
                </div>
                <div class="item-content" v-if="item.contentType !== 5">
                  <el-input v-model="item.withdrawTime" type="number" style="width: 250px">
                    <template slot="prepend">{{
                      item.contentType === 101 ? '通话持续时间' : '撤回时间'
                    }}</template>
                    <template slot="append">秒</template>
                  </el-input>
                </div>
                <div class="item-content" v-if="item.contentType == 5">
                  <span>开始时间:</span>
                  <el-date-picker v-model="item.startDate" type="date" placeholder="选择开始日期" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </div>
                <div class="item-content" v-if="item.contentType == 5">
                  <span>结束时间:</span>
                  <el-date-picker v-model="item.endDate" type="date" placeholder="选择结束日期" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </div>
                <div class="item-content" v-if="item.contentType == 5">
                  <span>执行时间:</span>
                  <el-time-picker v-model="item.execTime" value-format="HH:mm:ss" placeholder="任意时间点">
                  </el-time-picker>
                </div>
                <div class="item-content" v-if="item.contentType == 5">
                  <span>时区:</span>
                  <el-select v-model="item.timeZone" filterable clearable placeholder="请选择" style="width: 200px">
                    <el-option v-for="item in timeZoneList" :key="item.name" :label="item.name"
                      :value="item.value"></el-option>
                  </el-select>
                </div>
                <div class="item-content" v-if="item.contentType == 5">
                  <span>fcmTag(全局唯一):</span>
                  <el-input v-model="item.fcmTag" style="width: 250px"></el-input>
                </div>
                <div class="item-content" v-if="item.contentType == 5">
                  <span>标题:</span>
                  <el-input v-model="item.title" style="width: 250px"></el-input>
                </div>
                <div class="item-content" v-if="item.contentType == 5">
                  <span>内容:</span>
                  <el-input v-model="item.body" style="width: 250px" type="textarea" :rows="2"></el-input>
                </div>
                <div class="item-content" v-if="item.contentType == 5">
                  <span>图片:</span>
                  <el-input v-model="item.icon" style="width: 300px; margin-right: 10px" type="textarea"
                    :rows="2"></el-input>
                  <el-upload class="avatar-uploader" action="#" list-type="picture-card" :show-file-list="false"
                    :on-change="(file, fileList) =>
                      changfile(file, 'automessage/icon/', index)
                      " :on-remove="() => {
                        item.imageUrl = null
                        item.icon = null
                      }
                        " :auto-upload="false">
                    <img v-if="item.imageUrl" :src="item.imageUrl" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
                <div class="delete" @click="deleteNodeMseeage(index)">
                  x
                </div>
              </div>
            </transition-group>
          </draggable>
          <el-select v-model="messageType" filterable placeholder="请选择要添加的节点" style="width: 400px">
            <el-option v-for="item in autoMessageList" :key="item.value" :label="item.name"
              :value="item.value"></el-option>
          </el-select>
          <el-button prop="success" @click="addNodeMessage">添加</el-button>
        </el-row>
        <el-form-item>
          <el-button @click="resetForm('ruleForm', 0)">取消</el-button>
          <el-button type="primary" @click="createMessage('ruleForm')">立即创建</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'StrategyContentLibrary',
  components: {
    draggable,
  },
  props: {
    strategyTypeList: {
      type: Array,
      default: () => []
    },
    channelList: {
      type: Array,
      default: () => []
    },
    langList: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      total: 0,
      lastPage: 10,
      currentPage: 1,
      messageDialog: false,
      type: 0,
      autoMessageList: [
        { name: '文本', value: 1 },
        { name: '声音', value: 2 },
        { name: '图片', value: 3 },
        { name: '视频', value: 4 },
        { name: '电话', value: 101 },
        { name: 'FCM', value: 5 },
      ],
      urlTypeList: [
        { name: 'URL 上传', value: 1 },
        { name: '主播资料页获取', value: 2 },
      ],
      messageType: null,
      rules: {
        name: { required: true, message: '请输入策略名称', trigger: 'blur' },
        channel: { required: true, message: '请选择渠道', trigger: 'change' },
        strategyType: {
          required: true,
          message: '请选择策略类型',
          trigger: 'change',
        },
        lang: { required: true, message: '请选择语言', trigger: 'change' },
      },
      searchList: {
        strategyType: '',
        valid: null,
        lang: '',
      },
      form: {
        name: '',
        channel: '',
        strategyType: null,
        lang: '',
        remark: '',
      },
      messageList: [],
      loginMessage: [],
      totalPage: 10,
      pageSize: 30,
      timeZoneList: [
        {
          name: '本地时区',
          value: 'LOCAL',
        },
        {
          name: 'UTC时区',
          value: 'UTC',
        },
        {
          name: '北京时区',
          value: 'GMT+8:00',
        },
      ],
    }
  },
  mounted() {
    this.getAllMessage(0)
    this.getSelectAllMessage()
  },
  methods: {
    handleUrlTypeChange(item) {
      this.$forceUpdate();
    },
    async changfile(file, dir, index) {
      const formdata = new FormData()
      formdata.append('file', file.raw)
      formdata.append('cover', 0)
      formdata.append('dir', dir)
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formdata
      )

      if (res.code !== 0) {
        this.fileList = []
        return this.$message.error('文件上传失败请重新选择文件上传')
      }
      this.$set(this.loginMessage, index, {
        ...this.loginMessage[index],
        icon: res.data,
        imageUrl: res.data,
      })
    },
    getName(key, arr) {
      let name = ''
      arr.forEach((item) => {
        if (item.value == key) {
          name = item.name
          return
        }
      })
      return name
    },
    addMessage() {
      this.type = 0
      this.messageDialog = true
    },
    copyAutoMessage(data) {
      let info = JSON.parse(JSON.stringify(data))
      info.name = ''
      info.id = ''
      this.type = 0
      this.messageDialog = true
      this.form = info
      this.getMessageNode(info.name)
    },
    updateAutoMessage(data) {
      let info = JSON.parse(JSON.stringify(data))
      this.type = 1
      this.messageDialog = true
      // this.form = info
      this.$set(this, 'form', info)
      this.getMessageNode(info.name)
    },
    async getAllMessage(pages) {
      let page = pages ? pages : this.currentPage
      let info = {
        data: this.searchList,
        page: page,
      }

      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_autoMessage_query,
        data: info,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.totalPage = res.data.total
        this.messageList = res.data.list
      }
    },
    async getSelectAllMessage() {
      let info = {
        data: this.searchList,
        page: -1,
      }

      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_autoMessage_query,
        data: info,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.$emit('update:options', [
          {
            label: '全部',
            options: [
              {
                value: '',
                label: 'all',
              },
            ],
          },
          ...this.categorizeByLanguage(res.data.list),
        ])
      }
    },
    categorizeByLanguage(data) {
      const categorizedOptions = []
      const languageMap = new Map()

      data.forEach((item) => {
        const language = item.lang

        if (!languageMap.has(language)) {
          languageMap.set(language, [])
        }

        languageMap.get(language).push({
          value: item.name,
          label: item.name,
        })
      })

      languageMap.forEach((options, language) => {
        categorizedOptions.push({
          label: language,
          options: options,
        })
      })

      return categorizedOptions
    },
    async updateMessage(data) {
      let messageInfo = {
        data: JSON.parse(JSON.stringify(data)),
      }
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_autoMessage_update,
        data: messageInfo,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('修改成功')
        this.getAllMessage()
        this.getSelectAllMessage()
        this.resetForm('ruleForm', 0)
      }
    },
    async deleteMessage(id) {
      this.$confirm('删除后已生效的配置将失效，确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          if (!id) return this.$message.warning('用户id不存在')
          const { data: res } = await this.$axios({
            method: 'POST',
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json;',
            },
            url: this.$store.getters.path.config_autoMessage_delete,
            data: {
              id: id,
            },
            params: {
              username: this.$store.getters.username,
              token: this.$store.getters.token,
            },
          })

          if (res.code != 0) {
            return this.$message.error(res.msg)
          } else {
            this.$message.success('删除成功')
            this.getAllMessage()
            this.getSelectAllMessage()
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    changeValid(data) {
      const messageInfo = JSON.parse(JSON.stringify(data))
      messageInfo.valid = Math.abs(data.valid - 1)
      this.updateMessage(messageInfo)
    },
    formatDate(row, column) {
      let data = row[column.property] * 1000
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
    guaranteedHandleCurrentChange(page) {
      this.getAllMessage(page)
    },
    createMessage(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.loginMessage.length !== 0) {
            this.loginMessage.forEach((item, index) => {
              item.nodeIndex = index
              item.name = this.form.name
              item.delayTime = item.delayTime ? +item.delayTime : 0
              item.withdrawTime = item.withdrawTime ? +item.withdrawTime : 0

              if (item.contentType == 5) {
                item.content = JSON.stringify({
                  title: item.title,
                  body: item.body,
                  icon: item.icon,
                })
                delete item.title
                delete item.body
                delete item.icon
                delete item.imageUrl
              }
              if (item.urlType) {
                if (item.urlType == 2) {
                  item.url = ''
                }
                delete item.urlType
              }
            })
            this.updateMessageNode(this.loginMessage)
          }
          this.updateMessage(this.form)
        } else {
          return false
        }
      })
    },
    async getMessageNode(name) {
      let info = {
        data: {
          name: name,
        },
      }

      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json;  charset=UTF-8',
        },
        url: this.$store.getters.path.config_autoMessage_queryNodes,
        data: info,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        const list = res.data.list.map((item) => {
          if (item.contentType == 5) {
            const obj = JSON.parse(item.content)
            item.imageUrl = obj.icon || null
            return { ...item, ...obj }
          }
          if (item.url) {
            item.urlType = 1
          } else {
            item.urlType = 2
          }
          return item
        })
        console.log(list);
        this.$set(this, 'loginMessage', list)
      }
    },
    async updateMessageNode(data) {
      if (data.length <= 0) return
      data.forEach(item => {
        if (item.contentType == 5) {
          item.content = JSON.stringify({
            title: item.title,
            body: item.body,
            icon: item.icon,
          })
        }
      })
      let info = {
        list: data,
      }

      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json;  charset=UTF-8',
        },
        url: this.$store.getters.path.config_autoMessage_updateNode,
        data: info,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        return this.$message.success('节点更新成功')
      }
    },
    deleteNodeMseeage(index) {
      this.$confirm('是否删除该节点?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        if (
          !this.loginMessage[index].status &&
          this.loginMessage[index].status !== 0
        ) {
          const { data: res } = await this.$axios({
            method: 'POST',
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json;',
            },
            url: this.$store.getters.path.config_autoMessage_deleteNode,
            data: {
              id: this.loginMessage[index].id,
            },
            params: {
              username: this.$store.getters.username,
              token: this.$store.getters.token,
            },
          })

          if (res.code != 0) {
            return this.$message.error(res.msg)
          } else {
            this.$message.success('节点删除成功')
            this.loginMessage.splice(index, 1)
          }
        } else {
          this.loginMessage.splice(index, 1)
        }
      })
    },
    addNodeMessage() {
      if (this.messageType == null) {
        return this.$message.warning('请选择添加节点')
      }
      let length = this.loginMessage.length
      let nodeIndex = 0
      if (length !== 0) {
        nodeIndex = this.loginMessage[length - 1].nodeIndex + 1
      }
      this.loginMessage.push({
        contentType: this.messageType,
        nodeIndex: nodeIndex,
        status: 0,
      })
    },
    resetForm(formName, status) {
      if (status === 0) {
        this.$refs[formName].resetFields()
        Object.keys(this.form).forEach((key) => (this.form[key] = ''))
        this.loginMessage = []
        this.messageDialog = false
      }
    },
  }
}
</script>

<style scoped lang="scss">
.auto-message {
  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }
  }
}

.item {
  padding: 6px;
  background-color: #eff2ff;
  border: solid 1px #000;
  border-radius: 10px;
  height: auto;
  padding: 10px 10px;
  margin-bottom: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  position: relative;

  span {
    font-size: 20px;
    font-weight: bold;
  }

  .item-content {
    display: flex;
    align-items: center;
    height: 100%;

    span {
      font-weight: 500;
      font-size: 14px;
      margin-right: 15px;
    }

    .avatar-uploader {
      margin: 10px 0;

      .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }

      .el-upload:hover {
        border-color: #409eff;
      }

      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 150px;
        height: 150px;
        line-height: 150px;
        text-align: center;
      }

      .avatar {
        width: 150px;
        height: 150px;
        display: block;
      }
    }
  }

  .delete {
    height: 20px;
    width: 20px;
    border: 1px solid red;
    border-radius: 50%;
    text-align: center;
    line-height: 15px;
    font-size: 15px;
    cursor: pointer;
    position: absolute;
    top: -10px;
    right: -8px;
  }
}

.el-form-item .el-form-item__content {
  margin-left: 10px !important;
}
</style>